// @ts-strict-ignore
import { selectAuthCredentials } from './../../../selectors/selectors';
import { useSelector } from 'react-redux';
import * as API from '../../../api';
import { RootState } from '../../../reducers/reducers';
import { ScanResult } from '../../../types';
import { useState } from 'react';

export type ScanRepositoryHookData = [ScanResult | undefined, boolean, Error, () => Promise<void>];

export const useScanRepository: (orgId: string, appId: string) => ScanRepositoryHookData = (orgId, appId) => {
    const [scanResult, setScanResult] = useState<ScanResult | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const scanRepository = async () => {
        setIsLoading(true);
        try {
            const scanResults = await API.scanRepository({ orgId, appId }, authCredentials);

            setScanResult(scanResults);
        } catch (error) {
            setError(new Error(`Error scanning repository: ${error.message}`));
        } finally {
            setIsLoading(false);
        }
    };

    return [scanResult, isLoading, error, scanRepository];
};
